<template>
	<div class="multiple-select-settings-editor">
		<Container orientation="vertical" drag-handle-selector=".hover-effect" @drop="onDrop">
			<Draggable v-for="opt in optionsLocal" :key="opt.id">
				<SingleOption
					class="option-container mr-3"
					:ref="`option-ref-${opt.id}`"
					:data="opt"
					:is-option-value="isOptionValue"
					:keyPlaceholder="keyPlaceholder"
					:valuePlaceholder="valuePlaceholder"
					:noSuffix="noSuffix"
					:readonly="readonly"
					:can-remove="optionsLocal.length > 1"
					@updateOption="updateOption"
					@onEnterKey="addOption"
					@removeOption="removeOption"
					:allowMultipleValue="allowMultipleValue"
					:allowTableAndItemValue="allowTableAndItemValue"
				/>
			</Draggable>
		</Container>
		<div v-if="!readonly" class="add-option-container" @click="addOption">[+] {{ addOptionText || 'Add option' }}</div>
	</div>
</template>

<script>
import Vue from 'vue';

import { Draggable, Container } from 'vue-smooth-dnd';
import SingleOption from './SingleOption';
import { applyDrag } from '@/utils/helpers';

const getOption = (options, optionObj) => {
	const maxId = options.length === 0 ? 0 : Math.max(...options.map((o) => o.id));
	return { id: maxId + 1, ...optionObj };
};

export default {
	name: 'MultipleSelectSettingsEditor',
	components: {
		Draggable,
		Container,
		SingleOption,
	},
	props: {
		options: { type: Array },
		noSuffix: { type: Boolean },
		readonly: { type: Boolean },
		isOptionValue: { type: Boolean },
		keyPlaceholder: { type: String },
		valuePlaceholder: { type: String },
		addOptionText: { type: String },
		defaultOptionTemplate: { type: Object, default: () => ({ text: '', value: '' }) },
		allowMultipleValue: { type: Boolean },
		allowTableAndItemValue: { type: Boolean },
	},
	computed: {
		optionsLocal: {
			get() {
				return this.options || [];
			},
			set(value) {
				this.$emit('onChange', value);
			},
		},
	},

	methods: {
		onDrop(dropResult) {
			this.optionsLocal = applyDrag(this.optionsLocal, dropResult);
		},
		addOption() {
			const newOption = getOption(this.optionsLocal, this.defaultOptionTemplate);
			Vue.set(this, 'optionsLocal', [...this.optionsLocal, newOption]);
			this.$nextTick(() => {
				const ref = this.$refs[`option-ref-${newOption.id}`];
				if (ref) {
					ref[0].focusInput();
				}
			});
		},
		updateOption(optionData) {
			const optIndex = this.optionsLocal.findIndex((o) => o.id === optionData.id);
			const options = [...this.optionsLocal];
			Object.assign(options[optIndex], optionData);
			this.optionsLocal = options;
		},
		removeOption(opt) {
			this.optionsLocal = this.optionsLocal.filter((o) => o.id !== opt.id);
			this.$nextTick(() => {
				const ref = this.$refs[`option-ref-${opt.id - 1}`];
				if (ref) {
					ref[0].focusInput();
				}
			});
		},
	},
};
</script>

<style scoped lang="scss">
.multiple-select-settings-editor {
	::v-deep(.single-option) {
		background-color: var(--dialog-bg);
		border-radius: 4px;
		padding: 7px;
	}
	.option-container {
		margin: 7px;
	}
	::v-deep {
		.smooth-dnd-ghost {
			transform: translate(-50px, -50px) !important;
			margin-left: 0;
		}
	}
}

.add-option-container {
	font-size: 14px;
	color: var(--primary-color);
	cursor: pointer;
	margin: 8px 0;
}
</style>
